import { Route } from '@angular/router';
import {AboutUsComponent} from '@app/features/components/about-us/about-us.component';

export const AboutUsRoutes: Route[] = [
  {
    path: '',
    component: AboutUsComponent
  }
];
